import React, { useState } from "react";
import Orders from "../components/admin/Orders.js";
import Cart from "./Cart.js";
import Profile from "./Profile.js";

const Dashboard = () => {
  const [current, setCurrent] = useState("Profile");
  function profileHandler(e) {
    setCurrent(e.target.value);
  }
  function cartHandler(e) {
    setCurrent(e.target.value);
  }

  function allOrderHandler(e) {
    setCurrent(e.target.value);
  }

  return (
    <div style={{ marginTop: "100px" }}>
      <div className=" d-flex justify-content-center m-2 ">
        <button
          onClick={profileHandler}
          className="btn btn-danger  ml-2"
          value="Profile"
        >
          Profile
        </button>
        <button
          onClick={cartHandler}
          className="btn btn-info ml-2"
          value="My Oreder"
        >
          My Oreder
        </button>
        <button
          onClick={allOrderHandler}
          className="btn btn-danger ml-2"
          value="Manage Orders"
        >
          Manage All Orders
        </button>
      </div>
      <div ClassName="my-4 ">
        {(current === "Profile" && <Profile></Profile>) ||
          (current === "My Oreder" && <Cart></Cart>) ||
          (current === "Manage Orders" && <Orders></Orders>)}
      </div>
    </div>
  );
};

export default Dashboard;
